/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppFollowUpsRouteImport } from './routes/_app/follow-ups'
import { Route as AppSyncRouteImport } from './routes/_app/sync'
import { Route as ETokenRouteImport } from './routes/e.$token'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AppLeadsNewRouteImport } from './routes/_app/leads/new'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products.index'
import { Route as AppProductsNewRouteImport } from './routes/_app/products.new'
import { Route as AppReportsLeadsRouteImport } from './routes/_app/reports.leads'
import { Route as AppLeadsLeadIdIndexRouteImport } from './routes/_app/leads/$leadId.index'
import { Route as AppLeadsLeadIdEditRouteImport } from './routes/_app/leads/$leadId.edit'
import { Route as AppLeadsLeadIdQuoteRouteImport } from './routes/_app/leads/$leadId.quote'
import { Route as AppLeadsLeadIdSelectionRouteImport } from './routes/_app/leads/$leadId.selection'
import { Route as AppProductsItemNoIndexRouteImport } from './routes/_app/products.$itemNo.index'
import { Route as AppProductsItemNoEditRouteImport } from './routes/_app/products.$itemNo.edit'
import { Route as AppProductsPrintCatalogueRouteImport } from './routes/_app/products.print.catalogue'
import { Route as AppLeadsLeadIdAcceptRequestIdRouteImport } from './routes/_app/leads/$leadId.accept.$requestId'
import { Route as AppLeadsLeadIdPrintCatalogueSelectionIdRouteImport } from './routes/_app/leads/$leadId.print.catalogue.$selectionId'
import { Route as AppLeadsLeadIdPrintQuotationQuotationIdRouteImport } from './routes/_app/leads/$leadId.print.quotation.$quotationId'
import { Route as AppLeadsLeadIdPrintRequestRequestIdRouteImport } from './routes/_app/leads/$leadId.print.request.$requestId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpsRoute = AppFollowUpsRouteImport.update({
  id: '/follow-ups',
  path: '/follow-ups',
  getParentRoute: () => AppRoute,
} as any)
const AppSyncRoute = AppSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AppRoute,
} as any)
const ETokenRoute = ETokenRouteImport.update({
  id: '/e/$token',
  path: '/e/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLeadsNewRoute = AppLeadsNewRouteImport.update({
  id: '/leads/new',
  path: '/leads/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsNewRoute = AppProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsLeadsRoute = AppReportsLeadsRouteImport.update({
  id: '/reports/leads',
  path: '/reports/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdIndexRoute = AppLeadsLeadIdIndexRouteImport.update({
  id: '/leads/$leadId/',
  path: '/leads/$leadId/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdEditRoute = AppLeadsLeadIdEditRouteImport.update({
  id: '/leads/$leadId/edit',
  path: '/leads/$leadId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdQuoteRoute = AppLeadsLeadIdQuoteRouteImport.update({
  id: '/leads/$leadId/quote',
  path: '/leads/$leadId/quote',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdSelectionRoute = AppLeadsLeadIdSelectionRouteImport.update({
  id: '/leads/$leadId/selection',
  path: '/leads/$leadId/selection',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsItemNoIndexRoute = AppProductsItemNoIndexRouteImport.update({
  id: '/products/$itemNo/',
  path: '/products/$itemNo/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsItemNoEditRoute = AppProductsItemNoEditRouteImport.update({
  id: '/products/$itemNo/edit',
  path: '/products/$itemNo/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsPrintCatalogueRoute =
  AppProductsPrintCatalogueRouteImport.update({
    id: '/products/print/catalogue',
    path: '/products/print/catalogue',
    getParentRoute: () => AppRoute,
  } as any)
const AppLeadsLeadIdAcceptRequestIdRoute =
  AppLeadsLeadIdAcceptRequestIdRouteImport.update({
    id: '/leads/$leadId/accept/$requestId',
    path: '/leads/$leadId/accept/$requestId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLeadsLeadIdPrintCatalogueSelectionIdRoute =
  AppLeadsLeadIdPrintCatalogueSelectionIdRouteImport.update({
    id: '/leads/$leadId/print/catalogue/$selectionId',
    path: '/leads/$leadId/print/catalogue/$selectionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLeadsLeadIdPrintQuotationQuotationIdRoute =
  AppLeadsLeadIdPrintQuotationQuotationIdRouteImport.update({
    id: '/leads/$leadId/print/quotation/$quotationId',
    path: '/leads/$leadId/print/quotation/$quotationId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLeadsLeadIdPrintRequestRequestIdRoute =
  AppLeadsLeadIdPrintRequestRequestIdRouteImport.update({
    id: '/leads/$leadId/print/request/$requestId',
    path: '/leads/$leadId/print/request/$requestId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/follow-ups': typeof AppFollowUpsRoute
  '/sync': typeof AppSyncRoute
  '/e/$token': typeof ETokenRoute
  '/q/$token': typeof QTokenRoute
  '/s/$token': typeof STokenRoute
  '/leads/new': typeof AppLeadsNewRoute
  '/products/new': typeof AppProductsNewRoute
  '/reports/leads': typeof AppReportsLeadsRoute
  '/products/': typeof AppProductsIndexRoute
  '/leads/$leadId/edit': typeof AppLeadsLeadIdEditRoute
  '/leads/$leadId/quote': typeof AppLeadsLeadIdQuoteRoute
  '/leads/$leadId/selection': typeof AppLeadsLeadIdSelectionRoute
  '/products/$itemNo/edit': typeof AppProductsItemNoEditRoute
  '/products/print/catalogue': typeof AppProductsPrintCatalogueRoute
  '/leads/$leadId/': typeof AppLeadsLeadIdIndexRoute
  '/products/$itemNo/': typeof AppProductsItemNoIndexRoute
  '/leads/$leadId/accept/$requestId': typeof AppLeadsLeadIdAcceptRequestIdRoute
  '/leads/$leadId/print/catalogue/$selectionId': typeof AppLeadsLeadIdPrintCatalogueSelectionIdRoute
  '/leads/$leadId/print/quotation/$quotationId': typeof AppLeadsLeadIdPrintQuotationQuotationIdRoute
  '/leads/$leadId/print/request/$requestId': typeof AppLeadsLeadIdPrintRequestRequestIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/follow-ups': typeof AppFollowUpsRoute
  '/sync': typeof AppSyncRoute
  '/e/$token': typeof ETokenRoute
  '/q/$token': typeof QTokenRoute
  '/s/$token': typeof STokenRoute
  '/': typeof AppIndexRoute
  '/leads/new': typeof AppLeadsNewRoute
  '/products/new': typeof AppProductsNewRoute
  '/reports/leads': typeof AppReportsLeadsRoute
  '/products': typeof AppProductsIndexRoute
  '/leads/$leadId/edit': typeof AppLeadsLeadIdEditRoute
  '/leads/$leadId/quote': typeof AppLeadsLeadIdQuoteRoute
  '/leads/$leadId/selection': typeof AppLeadsLeadIdSelectionRoute
  '/products/$itemNo/edit': typeof AppProductsItemNoEditRoute
  '/products/print/catalogue': typeof AppProductsPrintCatalogueRoute
  '/leads/$leadId': typeof AppLeadsLeadIdIndexRoute
  '/products/$itemNo': typeof AppProductsItemNoIndexRoute
  '/leads/$leadId/accept/$requestId': typeof AppLeadsLeadIdAcceptRequestIdRoute
  '/leads/$leadId/print/catalogue/$selectionId': typeof AppLeadsLeadIdPrintCatalogueSelectionIdRoute
  '/leads/$leadId/print/quotation/$quotationId': typeof AppLeadsLeadIdPrintQuotationQuotationIdRoute
  '/leads/$leadId/print/request/$requestId': typeof AppLeadsLeadIdPrintRequestRequestIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/follow-ups': typeof AppFollowUpsRoute
  '/_app/sync': typeof AppSyncRoute
  '/e/$token': typeof ETokenRoute
  '/q/$token': typeof QTokenRoute
  '/s/$token': typeof STokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/leads/new': typeof AppLeadsNewRoute
  '/_app/products/new': typeof AppProductsNewRoute
  '/_app/reports/leads': typeof AppReportsLeadsRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/leads/$leadId/edit': typeof AppLeadsLeadIdEditRoute
  '/_app/leads/$leadId/quote': typeof AppLeadsLeadIdQuoteRoute
  '/_app/leads/$leadId/selection': typeof AppLeadsLeadIdSelectionRoute
  '/_app/products/$itemNo/edit': typeof AppProductsItemNoEditRoute
  '/_app/products/print/catalogue': typeof AppProductsPrintCatalogueRoute
  '/_app/leads/$leadId/': typeof AppLeadsLeadIdIndexRoute
  '/_app/products/$itemNo/': typeof AppProductsItemNoIndexRoute
  '/_app/leads/$leadId/accept/$requestId': typeof AppLeadsLeadIdAcceptRequestIdRoute
  '/_app/leads/$leadId/print/catalogue/$selectionId': typeof AppLeadsLeadIdPrintCatalogueSelectionIdRoute
  '/_app/leads/$leadId/print/quotation/$quotationId': typeof AppLeadsLeadIdPrintQuotationQuotationIdRoute
  '/_app/leads/$leadId/print/request/$requestId': typeof AppLeadsLeadIdPrintRequestRequestIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/follow-ups'
    | '/sync'
    | '/e/$token'
    | '/q/$token'
    | '/s/$token'
    | '/leads/new'
    | '/products/new'
    | '/reports/leads'
    | '/products/'
    | '/leads/$leadId/edit'
    | '/leads/$leadId/quote'
    | '/leads/$leadId/selection'
    | '/products/$itemNo/edit'
    | '/products/print/catalogue'
    | '/leads/$leadId/'
    | '/products/$itemNo/'
    | '/leads/$leadId/accept/$requestId'
    | '/leads/$leadId/print/catalogue/$selectionId'
    | '/leads/$leadId/print/quotation/$quotationId'
    | '/leads/$leadId/print/request/$requestId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/follow-ups'
    | '/sync'
    | '/e/$token'
    | '/q/$token'
    | '/s/$token'
    | '/'
    | '/leads/new'
    | '/products/new'
    | '/reports/leads'
    | '/products'
    | '/leads/$leadId/edit'
    | '/leads/$leadId/quote'
    | '/leads/$leadId/selection'
    | '/products/$itemNo/edit'
    | '/products/print/catalogue'
    | '/leads/$leadId'
    | '/products/$itemNo'
    | '/leads/$leadId/accept/$requestId'
    | '/leads/$leadId/print/catalogue/$selectionId'
    | '/leads/$leadId/print/quotation/$quotationId'
    | '/leads/$leadId/print/request/$requestId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/follow-ups'
    | '/_app/sync'
    | '/e/$token'
    | '/q/$token'
    | '/s/$token'
    | '/_app/'
    | '/_app/leads/new'
    | '/_app/products/new'
    | '/_app/reports/leads'
    | '/_app/products/'
    | '/_app/leads/$leadId/edit'
    | '/_app/leads/$leadId/quote'
    | '/_app/leads/$leadId/selection'
    | '/_app/products/$itemNo/edit'
    | '/_app/products/print/catalogue'
    | '/_app/leads/$leadId/'
    | '/_app/products/$itemNo/'
    | '/_app/leads/$leadId/accept/$requestId'
    | '/_app/leads/$leadId/print/catalogue/$selectionId'
    | '/_app/leads/$leadId/print/quotation/$quotationId'
    | '/_app/leads/$leadId/print/request/$requestId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ETokenRoute: typeof ETokenRoute
  QTokenRoute: typeof QTokenRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-ups': {
      id: '/_app/follow-ups'
      path: '/follow-ups'
      fullPath: '/follow-ups'
      preLoaderRoute: typeof AppFollowUpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sync': {
      id: '/_app/sync'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof AppSyncRouteImport
      parentRoute: typeof AppRoute
    }
    '/e/$token': {
      id: '/e/$token'
      path: '/e/$token'
      fullPath: '/e/$token'
      preLoaderRoute: typeof ETokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/leads/new': {
      id: '/_app/leads/new'
      path: '/leads/new'
      fullPath: '/leads/new'
      preLoaderRoute: typeof AppLeadsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/new': {
      id: '/_app/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AppProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/leads': {
      id: '/_app/reports/leads'
      path: '/reports/leads'
      fullPath: '/reports/leads'
      preLoaderRoute: typeof AppReportsLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/': {
      id: '/_app/leads/$leadId/'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId/'
      preLoaderRoute: typeof AppLeadsLeadIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/edit': {
      id: '/_app/leads/$leadId/edit'
      path: '/leads/$leadId/edit'
      fullPath: '/leads/$leadId/edit'
      preLoaderRoute: typeof AppLeadsLeadIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/quote': {
      id: '/_app/leads/$leadId/quote'
      path: '/leads/$leadId/quote'
      fullPath: '/leads/$leadId/quote'
      preLoaderRoute: typeof AppLeadsLeadIdQuoteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/selection': {
      id: '/_app/leads/$leadId/selection'
      path: '/leads/$leadId/selection'
      fullPath: '/leads/$leadId/selection'
      preLoaderRoute: typeof AppLeadsLeadIdSelectionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$itemNo/': {
      id: '/_app/products/$itemNo/'
      path: '/products/$itemNo'
      fullPath: '/products/$itemNo/'
      preLoaderRoute: typeof AppProductsItemNoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$itemNo/edit': {
      id: '/_app/products/$itemNo/edit'
      path: '/products/$itemNo/edit'
      fullPath: '/products/$itemNo/edit'
      preLoaderRoute: typeof AppProductsItemNoEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/print/catalogue': {
      id: '/_app/products/print/catalogue'
      path: '/products/print/catalogue'
      fullPath: '/products/print/catalogue'
      preLoaderRoute: typeof AppProductsPrintCatalogueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/accept/$requestId': {
      id: '/_app/leads/$leadId/accept/$requestId'
      path: '/leads/$leadId/accept/$requestId'
      fullPath: '/leads/$leadId/accept/$requestId'
      preLoaderRoute: typeof AppLeadsLeadIdAcceptRequestIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/print/catalogue/$selectionId': {
      id: '/_app/leads/$leadId/print/catalogue/$selectionId'
      path: '/leads/$leadId/print/catalogue/$selectionId'
      fullPath: '/leads/$leadId/print/catalogue/$selectionId'
      preLoaderRoute: typeof AppLeadsLeadIdPrintCatalogueSelectionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/print/quotation/$quotationId': {
      id: '/_app/leads/$leadId/print/quotation/$quotationId'
      path: '/leads/$leadId/print/quotation/$quotationId'
      fullPath: '/leads/$leadId/print/quotation/$quotationId'
      preLoaderRoute: typeof AppLeadsLeadIdPrintQuotationQuotationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId/print/request/$requestId': {
      id: '/_app/leads/$leadId/print/request/$requestId'
      path: '/leads/$leadId/print/request/$requestId'
      fullPath: '/leads/$leadId/print/request/$requestId'
      preLoaderRoute: typeof AppLeadsLeadIdPrintRequestRequestIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppFollowUpsRoute: typeof AppFollowUpsRoute
  AppSyncRoute: typeof AppSyncRoute
  AppIndexRoute: typeof AppIndexRoute
  AppLeadsNewRoute: typeof AppLeadsNewRoute
  AppProductsNewRoute: typeof AppProductsNewRoute
  AppReportsLeadsRoute: typeof AppReportsLeadsRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppLeadsLeadIdEditRoute: typeof AppLeadsLeadIdEditRoute
  AppLeadsLeadIdQuoteRoute: typeof AppLeadsLeadIdQuoteRoute
  AppLeadsLeadIdSelectionRoute: typeof AppLeadsLeadIdSelectionRoute
  AppProductsItemNoEditRoute: typeof AppProductsItemNoEditRoute
  AppProductsPrintCatalogueRoute: typeof AppProductsPrintCatalogueRoute
  AppLeadsLeadIdIndexRoute: typeof AppLeadsLeadIdIndexRoute
  AppProductsItemNoIndexRoute: typeof AppProductsItemNoIndexRoute
  AppLeadsLeadIdAcceptRequestIdRoute: typeof AppLeadsLeadIdAcceptRequestIdRoute
  AppLeadsLeadIdPrintCatalogueSelectionIdRoute: typeof AppLeadsLeadIdPrintCatalogueSelectionIdRoute
  AppLeadsLeadIdPrintQuotationQuotationIdRoute: typeof AppLeadsLeadIdPrintQuotationQuotationIdRoute
  AppLeadsLeadIdPrintRequestRequestIdRoute: typeof AppLeadsLeadIdPrintRequestRequestIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppFollowUpsRoute: AppFollowUpsRoute,
  AppSyncRoute: AppSyncRoute,
  AppIndexRoute: AppIndexRoute,
  AppLeadsNewRoute: AppLeadsNewRoute,
  AppProductsNewRoute: AppProductsNewRoute,
  AppReportsLeadsRoute: AppReportsLeadsRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppLeadsLeadIdEditRoute: AppLeadsLeadIdEditRoute,
  AppLeadsLeadIdQuoteRoute: AppLeadsLeadIdQuoteRoute,
  AppLeadsLeadIdSelectionRoute: AppLeadsLeadIdSelectionRoute,
  AppProductsItemNoEditRoute: AppProductsItemNoEditRoute,
  AppProductsPrintCatalogueRoute: AppProductsPrintCatalogueRoute,
  AppLeadsLeadIdIndexRoute: AppLeadsLeadIdIndexRoute,
  AppProductsItemNoIndexRoute: AppProductsItemNoIndexRoute,
  AppLeadsLeadIdAcceptRequestIdRoute: AppLeadsLeadIdAcceptRequestIdRoute,
  AppLeadsLeadIdPrintCatalogueSelectionIdRoute:
    AppLeadsLeadIdPrintCatalogueSelectionIdRoute,
  AppLeadsLeadIdPrintQuotationQuotationIdRoute:
    AppLeadsLeadIdPrintQuotationQuotationIdRoute,
  AppLeadsLeadIdPrintRequestRequestIdRoute:
    AppLeadsLeadIdPrintRequestRequestIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ETokenRoute: ETokenRoute,
  QTokenRoute: QTokenRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
